import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  alignSelf,
  alignContent,
  alignItems,
  flex,
  flexDirection,
  flexWrap,
  justifyContent,
  order,
  space,
  width,
} from 'styled-system';
import gridConfig from '../../themes/GridConfig';

const { vspace } = gridConfig;

// Get negative gutters.
const gutters = Object.keys(gridConfig.gutters).reduce((acc, cv) => {
  acc[cv] = `-${gridConfig.gutters[cv]}`;

  return acc;
}, {});

const StyledRow = styled.div(
  {
    boxSizing: 'border-box',
    display: 'flex',
  },
  alignSelf,
  alignContent,
  alignItems,
  flex,
  flexDirection,
  flexWrap,
  justifyContent,
  order,
  space,
  width
);

const negVSpace = Object.keys(vspace).reduce((acc, cv) => {
  acc[cv] = `-${gridConfig.vspace[cv]}`;

  return acc;
}, {});

function Row(props) {
  const { gutterless, last, children, ...other } = props;

  const columns = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      gutterless: gutterless || undefined,
    })
  );

  // mx sets the left and right margins
  // mb sets the bottom margin
  return (
    <StyledRow
      flexWrap="wrap"
      mx={gutters}
      {...(gutterless ? { m: gridConfig.resets } : {})}
      {...(last ? { mb: negVSpace } : {})}
      {...other}
    >
      {columns}
    </StyledRow>
  );
}

// Redefine the propTypes from styled system
Row.propTypes = {
  gutterless: PropTypes.bool,
  last: PropTypes.bool,
  ...alignSelf.propTypes,
  ...alignContent.propTypes,
  ...alignItems.propTypes,
  ...flex.propTypes,
  ...flexDirection.propTypes,
  ...flexWrap.propTypes,
  ...justifyContent.propTypes,
  ...order.propTypes,
  ...space.propTypes,
  ...width.propTypes,
};

Row.defaultProps = {
  gutterless: false,
  last: false,
};

/* @component */
export default Row;
